import axios from "axios";
import { useEffect, useMemo, useState } from "react";

export default function useCurrentIP() {
  const [ip, setIp] = useState(null);

  useEffect(() => {
    const fetchIP = async () => {
      try {
        const response = await axios.get("https://api.ipify.org?format=json");
        const r = response.data.ip;
        setIp(r);
      } catch (error) {
        console.error("Error fetching IP address:", error);
      }
    };

    fetchIP();
  }, []);

  const memoizedIp = useMemo(() => ip, [ip]);

  return memoizedIp;
}
